/* src/views/admin/kitchen/components/Toolbar.jsx */
import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleAdminSideDrawer } from '@/store/uiSlice';

/* ─ Tabs ─ */
const TABS = [
  { key: 'ALL',       label: 'All Orders' },
  { key: 'CONFIRMED', label: 'Confirmed'  },
  { key: 'PREPARING', label: 'Preparing'  },
  { key: 'DONE',      label: 'Done'       },
];

/* ─ Icons ─ */
const Magnifier = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-5 w-5 text-[#A0A7D1] pointer-events-none"
    fill="none"
    stroke="currentColor"
  >
    <circle cx="11" cy="11" r="7" strokeWidth="2" />
    <line x1="16.5" y1="16.5" x2="22" y2="22" strokeWidth="2" />
  </svg>
);

const FullScreenIcon = ({ cls = 'h-5 w-5' }) => (
  <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor">
    <polyline points="3 9 3 3 9 3" strokeWidth="2" />
    <polyline points="15 3 21 3 21 9" strokeWidth="2" />
    <polyline points="21 15 21 21 15 21" strokeWidth="2" />
    <polyline points="9 21 3 21 3 15" strokeWidth="2" />
  </svg>
);

/* ─ Component ─ */
export default function Toolbar({ activeTab, onTabChange, search, onSearch }) {
  const dispatch = useDispatch();

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
      {/* Pills */}
      <div className="flex gap-3 flex-wrap">
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => onTabChange(t.key)}
            className={`h-11 min-w-[110px] px-6 rounded-full font-medium text-sm transition
              ${
                activeTab === t.key
                  ? 'bg-[#0A66FF] text-white shadow'
                  : 'bg-white border border-[#D9D9E3] text-gray-700 hover:bg-gray-50'
              }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Search + sidebar toggle */}
      <div className="flex items-center gap-4">
        {/* search */}
        <label
          htmlFor="orderSearch"
          className="flex items-center h-12 w-96 max-w-full rounded-full
                     border border-[#B9C2FF] bg-white focus-within:ring-2
                     focus-within:ring-[#0A66FF] transition"
        >
          <span className="ml-4 flex items-center">
            <Magnifier />
          </span>

          <input
            id="orderSearch"
            value={search}
            onChange={e => onSearch(e.target.value)}
            placeholder="Search Order"
            className="flex-1 h-full bg-transparent pl-3 pr-4 text-sm
                       placeholder-gray-400 outline-none"
          />
        </label>

        {/* full-screen toggle */}
        <button
          title="Hide / show sidebar"
          onClick={() => dispatch(toggleAdminSideDrawer())}
          className="h-11 w-11 flex items-center justify-center rounded-full border border-[#D9D9E3]
                     hover:bg-gray-50 transition"
        >
          <FullScreenIcon />
        </button>
      </div>
    </div>
  );
}
